module.exports = {
    apiServerUrl: 'https://api-testing.amplement.io',
    publicHostname: 'https://www.testing.amplement.com',
    websocketHostname: 'https://api-testing.amplement.io',
    debug: true,
    logLevel: 'debug',
    logFilter: 'myc:*',
};
